import { NetworkStatus } from '@apollo/client';

import { useCompanyTagsPaginationPresenter } from 'application/presenters';
import { GetCompanyTagsType } from 'application/presenters/company/types';
import { useAccountCompanyId } from 'application/hooks';
import useCompanyTags from '@entities/company/api/useCompanyTags';

import { TagFiltersViewModel } from './types';

const useTagFiltersPresenter = (): TagFiltersViewModel => {
  const companyId = useAccountCompanyId();

  const [requestCompanyTagsQuery, companyTagsResult] = useCompanyTags();

  const getCompanyTags = async ({ filters, pagination }: GetCompanyTagsType) => {
    await requestCompanyTagsQuery(filters, pagination);
  };

  const getMoreCompanyTags = async ({ filters, pagination }: GetCompanyTagsType) => {
    await companyTagsResult.loadMore(filters, pagination);
  };

  const companyTagsData = companyTagsResult.data;
  const companyTagsNetworkStatus = companyTagsResult.networkStatus;
  const companyTagsCalled = companyTagsResult.called;

  const {
    companyTags,
    paginationInfo,
    allCompanyTagsCount,
    filtersRef,
    requestCompanyTags,
    loadMoreCompanyTags,
    resetFilters,
    onFilterExecute,
  } = useCompanyTagsPaginationPresenter({ getCompanyTags, getMoreCompanyTags, companyTagsData });

  const companyTagsLoading =
    companyTagsNetworkStatus === NetworkStatus.loading || companyTagsNetworkStatus === NetworkStatus.setVariables;

  const isReady = companyTagsCalled && (!companyTagsLoading || companyTags.length !== 0);

  const isFilterQueryEmpty = !filtersRef.current.query;

  const isEmpty = isReady && companyTags.length === 0 && isFilterQueryEmpty;

  const isEmptyFiltered = isReady && companyTags.length === 0 && !isFilterQueryEmpty;

  return {
    companyId,
    isReady,
    isEmpty,
    isEmptyFiltered,
    companyTags,
    paginationInfo,
    companyTagsLoading,
    allCompanyTagsCount,
    requestCompanyTags,
    loadMoreCompanyTags,
    resetFilters,
    onFilterExecute,
  };
};

export default useTagFiltersPresenter;
